module.exports = __webpack_public_path__ + "assets/img/empty.a23a1352.png";